import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { DefaultTransactionColumnHeader } from "./DefaultTransactionColumnHeader";
import { TransactionColumnFilterMerchant } from "./TransactionColumnFilterMerchant";

export function TransactionColumnHeaderMerchant(): JSX.Element {
  return (
    <TransactionColumnSizer column={TransactionColumn.MERCHANT}>
      <DefaultTransactionColumnHeader
        column={TransactionColumn.MERCHANT}
        text={"Merchant"}
        FilterType={TransactionColumnFilterMerchant}
      />
    </TransactionColumnSizer>
  );
}
